import type { IconSvgObject } from './types';

const Award05Icon: IconSvgObject = [
  ["path", { d: "M19 8.6852C19 12.8768 15.866 16 12 16C8.13401 16 5 12.8167 5 8.6852C5 4.99306 8.13401 2 12 2C15.866 2 19 4.99306 19 8.6852Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.57156", key: "0" }],
  ["path", { d: "M10 9L11.5 10.5L14 7.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M8 14.5L7 22L12 20L17 22L16 14.5", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default Award05Icon;
